import { AppService, DomainTypes } from "../DomainTypes";
import { ConfigValues } from "../Models/Config/TenantConfig";

class TextValues {

    public distribution: string = "Dividend";

    public get distributionLowerCase() {
        return this.distribution.toLowerCase();
    }

    public updateFromConfig(config: ConfigValues) {
        this.distribution = config.distributionWording ?? "Dividend";
    }

    public async initialise() {
        const tenantConfig = await AppService.get(DomainTypes.Services.DataCache).tenantConfig.getDataAsync();
        this.updateFromConfig(tenantConfig);
    }
}

export default new TextValues();